module.exports = __webpack_public_path__ + "static/media/settings-1.cd101e7e.svg";